/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {GetInfluencerList, SendSMS} from '../../modules/api/_requests'
import AuthService from '../../modules/auth/redux/AuthService'
import {ListTableWidget} from './components/ListTableWidget'
import {FilterSearchModel, FilterModel} from '../../types/index'
import SMSModalCard from './components/SMSModalCard'

type Props = {
  isAdmin: boolean | undefined
  handleSMSSent: (requestId: string) => void
}

const ListPage: FC<Props> = ({isAdmin, handleSMSSent}) => {
  const [influencers, setInfluencers] = useState<any[] | undefined>()
  const [newInfluencers, setNewInfluencers] = useState<any[] | undefined>()
  const [model, setModel] = useState<FilterModel | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    if (!isAdmin) {
      setModel({
        ...model,
        SalesPersonUserName: localStorage.getItem('salesPersonUsername'),
      })
    } else if(isAdmin) {
      setModel({...model, SalesPersonUserName: null})
      setIsLoading(false)
    }
  }, [isAdmin])


  useEffect(() => {
    if(isAdmin === true) {
      if(model?.RequestStatus || model?.StartCreateDate || model?.EndCreateDate || model?.StartAprrovalDate || model?.EndAprrovalDate) {GetInfluencerList(model, setInfluencers, setIsLoading)}
    } else {
      model && model.SalesPersonUserName && GetInfluencerList(model, setInfluencers, setIsLoading)
    }
  }, [model])

  return (
    <div className='card'>
      <h3 className='card-header d-flex align-items-center'>
        {isAdmin ? 'Influencer' : 'Kişi'} Listesi
      </h3>

      <div className='card-body'>
        <ListTableWidget
          className={''}
          isAdmin={isAdmin}
          isLoading={isLoading}
          influencers={influencers}
          model={model}
          setModel={setModel}
          handleSMSSent={handleSMSSent}
        />
      </div>
    </div>
  )
}

const ListWrapper: FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [SMSModal, setSMSModal] = useState<boolean>(false)
  const [SMSResponseLoading, setSMSResponseLoading] = useState<boolean>(false)
  const [SMSConfirm, setSMSConfirm] = useState<boolean | undefined>()
  const [isAdmin, setIsAdmin] = useState<boolean | undefined>()

  const intl = useIntl()

  const checkAdmin = () => {
    if (!localStorage.getItem('salesPersonUsername')) {
      setIsLoading(false)
      return true
    } else {
      setIsLoading(false)
      return false
    }
  }

  useEffect(() => {
    setIsAdmin(checkAdmin())
  }, [])

  const handleSMSSent = (requestId: string) => {
    setSMSModal(true)
    SendSMS(parseInt(requestId), setSMSConfirm, setSMSResponseLoading, setSMSModal)
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      {!isLoading && <ListPage isAdmin={isAdmin} handleSMSSent={handleSMSSent} />}
      {SMSModal && <SMSModalCard SMSConfirm={SMSConfirm} SMSResponseLoading={SMSResponseLoading} />}
    </>
  )
}

export {ListWrapper}
